import { keepPreviousData, useQuery } from "@tanstack/react-query"

import { getAffiliateCampaignDetails, getAffiliateCampaignPreviewDetails } from "@/api"
import { ACTION_NATIVE } from "@/modules/helpers/enum"
import type { AffiliateCampaign } from "@/modules/types"

export const useQueryCampaignById = (id?: string) => {
  const query = useQuery({
    queryKey: [id],
    enabled: !!id,
    queryFn: () => getAffiliateCampaignDetails(id as string),
    staleTime: 5 * 60 * 1000, // 5 minutes
    placeholderData: keepPreviousData,
    select: (data) => data?.data?.data as unknown as AffiliateCampaign
  })
  const refetch = async () => {
    try {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: ACTION_NATIVE.HAPTIC
        })
      )
    } catch {
      // Ignore haptic errors in web environment
    }
    query.refetch()
  }
  return { ...query, refetch }
}

export const useQueryCampaignPreviewById = (id?: string | null, accessToken?: string | null) => {
  const query = useQuery({
    queryKey: [id],
    enabled: !!id && !!accessToken,
    queryFn: () => getAffiliateCampaignPreviewDetails(id as string, accessToken as string),
    staleTime: 5 * 60 * 1000, // 5 minutes
    placeholderData: keepPreviousData,
    select: (data) => data?.data?.data as unknown as AffiliateCampaign
  })
  const refetch = async () => {
    try {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: ACTION_NATIVE.HAPTIC
        })
      )
    } catch {
      // Ignore haptic errors in web environment
    }
    query.refetch()
  }
  return { ...query, refetch }
}
